import React from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    CalendarIcon,
    RupeeIcon
} from "../../Styles/InputStyle2";
import { Select, MenuItem } from "@mui/material";
// import DropzoneImageUpload from "../Properties/DropzoneImageUpload";
import DropzoneImageUpload from "../../Properties/DropzoneImageUpload";
import { FaUserPlus } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { toast, ToastContainer } from "react-toastify";
import { MdClose } from "react-icons/md";

const EditDocuments = ({ onClose, stepOneData, setSelectedForm,setEditDocuments }) => {
    const initialValues = {
        invoice: null,
        Warranty: null,
        assets: null,

    };
    const handleBack = () => {
        setEditDocuments(false);
        // setSelectedForm("4");
    }

    const handleSubmit = (values) => {
        toast.success("Documents Edit Successfully");
        console.log(values);
        setEditDocuments(false);
    };

    return (

        <Container>
            <Header>
                <Title>{"Edit Documents"}</Title>
                <CloseButton onClick={() => setEditDocuments(false)}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>
                <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue }) => (
                        <Form className="px-2">
                            {/* <ModalSubHeading>Step 5</ModalSubHeading> */}
                            {/* <ModalHeading>Supporting Documents Details</ModalHeading> */}
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="invoice">
                                            Upload Invoice
                                            {/* <span className="text-red-500">*</span> */}
                                        </Label>
                                        <div>
                                            <DropzoneImageUpload
                                                setUploadFile={(file) => (values.tenantDocumentImage = file)}
                                                componentFor="invoice"
                                            />
                                        </div>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="Warranty">
                                            Warranty Document
                                            {/* <span className="text-red-500">*</span> */}
                                        </Label>
                                        <div>
                                            <DropzoneImageUpload
                                                setUploadFile={(file) => (values.tenantDocumentImage = file)}
                                                componentFor="Warranty"
                                            />
                                        </div>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="assets">
                                            Upload Asset Images
                                            {/* <span className="text-red-500">*</span> */}
                                        </Label>
                                        <div>
                                            <DropzoneImageUpload
                                                setUploadFile={(file) => (values.tenantDocumentImage = file)}
                                                componentFor="assets"
                                            />
                                        </div>
                                    </InputGroup>


                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleBack}>
                                    Back
                                </SideCancelBtn>
                                <SubmitBtn type="submit">
                                    Submit
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Container>
    );
};
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;


export default EditDocuments;